import pluginId from '../pluginId';

const getTranslation = (id) => `${pluginId}.${id}`;

export { getTranslation };